import Instance from '../../../../Axios';

// New Actions for the app

const GetEstadosControlo = () => async (dispatch) => {
  await Instance()
    .get(`/energias/estadosControlo`)
    .then(({ data }) => {
      //   console.log(data);
      dispatch({ type: 'GET_ENERGIAS_ESTADOS_CONTROLO', payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetEstadosControlo;
